import * as React from "react";
import Box from "@mui/material/Box";
import WindPlot from "../wind";
import WeatherPlot from "../weather";
import PressurePlot from "../pressure";
import { a11yProps, CustomTabPanel, getStationData } from "../util";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";


export default function Sempachersee ({ forecast }) {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let [vmax_sem, speed_sem, dir_sem, t2m_sem, precip_sem, dursun_sem, twater_sem, qff_sem] = getStationData(forecast, "SEM", "sempach", "QFF_KLO_GVE");
  let [vmax_eic, speed_eic, dir_eic, t2m_eic, precip_eic, dursun_eic, twater_eic, qff_eic] = getStationData(forecast, "EIC", "sempach", "QFF_KLO_GVE");

  return (
    <div>
      <title>Sempachersee Windvorhersage - Surfwetter</title>
      <div className="App">
        <div className="Content">
          <h2>Sempachersee</h2>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs value={value} onChange={handleChange} aria-label="tabs" variant="fullWidth">
                <Tab label="Nottwil" {...a11yProps(0)} />
                <Tab label="Eich" {...a11yProps(1)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <Box sx={{ overflow: "auto" }}>
                <WindPlot vmax={vmax_sem} speed={speed_sem} dir={dir_sem} />
                <PressurePlot qff={qff_sem} label="Zürich − Lugano" label_plus="Nordwind" label_minus="Föhn" />
                <WeatherPlot t2m={t2m_sem} precip={precip_sem} sun={dursun_sem} twater={twater_sem} />
              </Box>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <Box sx={{ overflow: "auto" }}>
                <WindPlot vmax={vmax_eic} speed={speed_eic} dir={dir_eic} />
                <PressurePlot qff={qff_eic} label="Zürich − Lugano" label_plus="Nordwind" label_minus="Föhn" />
                <WeatherPlot t2m={t2m_eic} precip={precip_eic} sun={dursun_eic} twater={twater_eic} />
              </Box>
            </CustomTabPanel>
          </Box>
        </div>
      </div>
    </div>
  );
};
